import {
    isCampaignManufacturer,
    isCampaignDropShipping,
    isCampaignMarketSearch,
    isPriceViolationTabShown,
    isAdmin,
} from "../../utils/Utils";
import { isMarketplaceOperatorCampaign } from "../Campaign/marketplaceOperatorSettings";

// Detail-page profile. heroType drives DecisionHero; rangeVizType drives the
// Overview band; deepTab is the profile-specific 4th tab.
const PROFILES = {
    competitive:  { key: 'competitive',  accent: '#2563eb', heroType: 'competitive', rangeVizType: 'price-band', deepTab: 'pricing' },
    brand:        { key: 'brand',        accent: '#7c3aed', heroType: 'brand',       rangeVizType: 'allowed-band', deepTab: 'compliance' },
    dropshipping: { key: 'dropshipping', accent: '#16a34a', heroType: 'dropshipping', rangeVizType: 'price-band', deepTab: 'pricing' },
    marketplace:  { key: 'marketplace',  accent: '#2563eb', heroType: 'marketplace', rangeVizType: 'none', deepTab: null },
    marketsearch: { key: 'marketsearch', accent: '#6b7280', heroType: 'marketsearch', rangeVizType: 'price-band', deepTab: null },
};

// campaign -> profile object. Falls back to competitive.
export const resolveProfile = (campaign) => {
    if (isMarketplaceOperatorCampaign(campaign)) return PROFILES.marketplace;
    if (isCampaignManufacturer(campaign)) return PROFILES.brand;
    if (isCampaignDropShipping(campaign)) return PROFILES.dropshipping;
    if (isCampaignMarketSearch(campaign)) return PROFILES.marketsearch;
    return PROFILES.competitive; // seller / unknown
};

// Single-tier tab keys for a profile, in display order. The product summary opens
// from the header popup (no Overview tab). 'compliance' uses the price-violation view.
//
// Each primary tab sits next to its own suggestions tab -- Sellers then
// Suggested Sellers, Suppliers then Suggested Suppliers -- rather than
// grouping the supplier pair ahead of the seller pair's own suggestions tab.
export const profileTabKeys = (campaign) => {
    const p = resolveProfile(campaign);
    const tabs = ['sellers', 'suggestions'];
    // Suppliers are a separate dataset from sellers, and only exist while the
    // campaign's supplier module is on.
    if (campaign?.settings?.supplier_module?.is_active) tabs.push('suppliers', 'supplier_suggestions');
    // Price History must always follow Dynamic Pricing when the profile has
    // one, but must not become conditional on it -- profiles without a
    // pricing deepTab (e.g. market search) still get a history tab.
    if (p.deepTab === 'pricing') tabs.push('pricing');
    tabs.push('history');
    if (p.deepTab === 'compliance' || isPriceViolationTabShown(campaign)) tabs.push('compliance');
    if (isAdmin()) tabs.push('search'); // admin-only: why this product's search found what it found
    if (isAdmin()) tabs.push('admin'); // admin-only tab, always last
    return tabs;
};

// Icon per tab key. The two suggestion tabs get their own icons rather than
// falling through to a shared default -- 'user-plus' pairs with Sellers
// (a new seller candidate), 'box' pairs with Suppliers (a new source/goods
// candidate), and the two read distinctly from each other.
//
// 'pi-truck' was never a real PrimeIcons 5.0 class (verified against
// node_modules/primeicons/primeicons.css), so the Suppliers tab silently
// rendered no icon at all -- 'pi-building' (the supplier organization) is
// confirmed present and reads as the counterpart to 'pi-box' (a new
// candidate source) on Suggested Suppliers.
export const tabIcon = {
    overview: 'pi pi-th-large', sellers: 'pi pi-sitemap', suggestions: 'pi pi-user-plus',
    suppliers: 'pi pi-building', supplier_suggestions: 'pi pi-box',
    pricing: 'pi pi-compass', history: 'pi pi-chart-line', compliance: 'pi pi-eye',
    search: 'pi pi-search', admin: 'pi pi-cog',
};
